angular.module('MyHippoProducer.Controllers').directive('optionalWatercraftCoverageSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/optional-watercraft-coverage/optional-watercraft-coverage.html',
    };
});
